import React from 'react';
import {Container, Row, Col, Card, Button} from 'react-bootstrap';
import userguide from './home_assets/user_guide.svg';
import cardguide from './home_assets/card_img.svg';

import './home_styles/homeuserguide.css';

export default function HomeUserguide() {
  return (
    <>
     <Container className='mt-5 mb-5'>
        <Row>
            <Col>
              <div className="user_guide_upper">
                <div className="guide_upper_img text-center">
                  <img src={userguide} alt="Userguide" />
                </div>
                <div className="guide_upper_head d-flex flex-column align-items-center">
                  <h1>NEW USER GUIDE</h1>
                  <span>Start learning digital currency trading now</span>
                </div>
              </div>
              <div className="lower_user_guide d-flex justify-content-between-lg mt-5">
                <div className="low_user_guide_card">
                <Col size={3}>
                <Card className='low_user_card'>
                  <img src={cardguide} className='' alt="" />
                </Card>
                </Col>
                <div className='lower_user_guide_span lower_span_1 text-center'>
                  <span>Lorem ipsum dolor sit amet.</span>
                </div>
                </div>
                <div className="low_user_guide_card">
                <Col size={3}>
                <Card className='low_user_card'>
                  <img src={cardguide} className='' alt="" />
                </Card>
                </Col>
                <div className='lower_user_guide_span lower_span_2 text-center'>
                  <span>Lorem ipsum dolor sit amet.</span>
                </div>
                </div>
                <div className="low_user_guide_card">
                <Col size={3}>
                <Card className='low_user_card'>
                  <img src={cardguide} className='' alt="" />
                </Card>
                </Col>
                <div className='lower_user_guide_span lower_span_3 text-center'>
                  <span>Lorem ipsum dolor sit amet.</span>
                </div>
                </div>
              </div>
              <div className="low_user_guide_btn mt-5 mb-5 d-flex justify-content-center">
                  <Button className='w-100'>Start learning digital currency trading now</Button>
              </div>
            </Col>
        </Row>
     </Container>
    </>
  )
}